import styled from 'styled-components';

export const Superscript = styled.sup`
  font-size: 75%;
  vertical-align: super;
`;
